import type { FormRenderer } from '@fusion-advantage/formrender'
import { AppThunk } from '../appStore'
import { serializeFusionError } from '@fusion-advantage/backcompat'
import { RootRouteContentType } from '@fusion-advantage/formlib'
import { appFormSave } from '../../lib/persistence/appFormSave'
import { appError } from '../errorSlice'
import { setAppContent } from '../appSlice'

export const setRenderInstance = (id: string, instance: FormRenderer): AppThunk<void> => (dispatch, getState, { renderInstances }) => {
	renderInstances.set(id, instance)
}

export const deleteRenderInstance = (id: string): AppThunk<void> => (dispatch, getState, { renderInstances }) => {
	renderInstances.delete(id)
}

export const saveAndReturnToDashboard = (): AppThunk<Promise<void>> => async (dispatch, getState, { renderInstances }) => {
	const content = getState().app.content
	switch(content.type) {
		case RootRouteContentType.Dashboard:
			// already on dashboard; no form in progress to save
			return
		case RootRouteContentType.Form:
			const instance = renderInstances.get(content.renderInstanceId)
			const appFormRelay = instance?.appFormRelay
			// it is possible that the render instance hasn't been created yet;
			// and if so there is nothing to save anyway
			if(!appFormRelay) {
				dispatch(setAppContent({type: RootRouteContentType.Dashboard}))
				return
			}
			await dispatch(appFormSave({
				appFormRelay: instance.appFormRelay,
				ignoreDraftProposalError: true,
				closeOnSuccess: true,
			}))
			return
		default:
			dispatch(appError({
				err: serializeFusionError('saveAndReturnToDashboard', `unhandled content type`)
			}))
	}
}
